module.exports = __webpack_public_path__ + "static/media/icon-home-white.d46f74fd.svg";